import React from 'react';
import PropTypes from 'prop-types';

import DefaultInput from './index';

const Input = ({
  input,
  type,
  id,
  className,
  placeholder,
  icon,
  meta: { touched, error },
}) => {
  return (
    <DefaultInput
      {...input}
      id={id}
      className={className}
      placeholder={placeholder}
      type={type}
      error={touched && error}
      icon={icon}
      border
    />
  );
};

Input.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  input: PropTypes.shape({
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  }).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool.isRequired,
    error: PropTypes.string,
  }).isRequired,
  icon: PropTypes.string,
};

Input.defaultProps = {
  className: '',
  id: null,
  type: 'text',
  placeholder: '',
  icon: null,
};

export default Input;



// WEBPACK FOOTER //
// ./src/components/Input/redux-form.js